import { render } from "./concursos.vue?vue&type=template&id=7efcab1c"
import script from "./concursos.vue?vue&type=script&lang=js"
export * from "./concursos.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__